import { usState } from "./states";

export interface LocationInfoModel {
    // Location Information
    address: string;
    city: string;
    state: usState | null;
    zip: string;
}

export interface LocationInfoErrors {
    addressError: boolean;
    cityError: boolean;
    stateError: boolean;
    zipError: boolean;

    errors: string[];
}

export const validateLocationInfo = (locationInfo: LocationInfoModel) : LocationInfoErrors => { 
    
    let errors: LocationInfoErrors = {
        addressError: false,
        cityError: false,
        stateError: false,
        zipError: false,
        errors: []
    };
    
    // Validate Address - We could add more robust validation here in the future
    if (locationInfo.address === '') {
        errors.addressError = true;
        errors.errors.push('Address is required');
    }

    // Validate City - We could add more robust validation here in the future
    if (locationInfo.city === '') {
        errors.cityError = true;
        errors.errors.push('City is required');
    }

    // Validate State
    if (locationInfo.state === null) {
        errors.stateError = true;
        errors.errors.push('State is required');
    }

    // validate Zip Code
    if (locationInfo.zip === '') {
        errors.zipError = true;
        errors.errors.push('Zip Code is required');
    } else if (!/^\d{5}(-\d{4})?$/.test(locationInfo.zip)) {
        errors.zipError = true;
        errors.errors.push('A valid Zip Code is required');
    }

    return errors;
}

export const defaultLocationInfoModel = () : LocationInfoModel => {
    return {
        // Location Information
        address: '',
        city: '',
        state: null,
        zip: ''
    };
}